<template>
  <a
    v-if="link"
		:href="link"
		target="_blank"
    :class="classes"
    :disabled="disabled"
    :style="`width: ${width_btn}; height: ${height_btn}; ${border_bold ? 'border-width: 1.5px' : ''}`"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <slot></slot>
  </a>
  <button
    v-else
    :class="classes"
    :disabled="disabled"
    :style="`width: ${width_btn}; height: ${height_btn}; ${border_bold ? 'border-width: 1.5px' : ''}`"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    /**
     * Цвет кнопки (green, orange, gray)
     */
    color: {
      type: String,
      required: true
    },
    /**
     * Если выставлен параметр, то кнопка будет большой
     */
    big: Boolean,
    /**
     * Отключает кнопку
     */
    disabled: Boolean,
    /**
     * Делает кнопку прозрачной и даёт обводку
     */
    outline: Boolean,

    /**
     * Добавляет класс active
     */
    active: Boolean,
    /**
     * ширина кнопки
     */
    width_btn: {
      type: String,
      default: ""
    },
    /**
     * высота кнопки
     */
    height_btn: {
      type: String,
      default: ""
    },
    border_bold: Boolean,
		link: {
			type: String,
			default: ''
		},

  },
  computed: {
    classes() {
      return {
        button: true,
        "d-flex align-center justify-center": true,
        green: this.color === "green",
        lightGreen: this.color === "lightGreen",
        orange: this.color === "orange",
        gray: this.color === "gray",
        white: this.color === "white",
        big: this.big,
        outline: this.outline,
        active: this.active
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

//Состояние кнопки по дефолту
.button {
  min-width: 6.9333rem;
  min-height: 2.9333rem;
  padding: 0.525rem 0.875rem 0.6875rem;

  font-weight: normal;
  line-height: 1.5;
  text-align: center;
  color: $text-super-light;
  letter-spacing: 0.0067rem;

  border-radius: 0.3333rem;
  cursor: pointer;
}

.white {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  // min-width: unset;
  // min-height: unset;
  border-radius: 0.3333rem;
  background-color: $bg-main;
  color: $text-white_btn;
  fill: $text-white_btn;
  -webkit-text-fill-color: $text-white_btn;
  &:hover {
    background-color: #f9f9f9;
    // color: rgba($text-white_btn, 1);
    // fill: rgba($text-white_btn, 1);
    // -webkit-text-fill-color: rgba($text-white_btn, 1);
  }
  &:active {
    background-color: $soft;
  }
  &.active i {
    transition: 0s;
    color: $active;
    fill: $active;
    -webkit-text-fill-color: $active;
  }
}
.green {
  background-color: $active;
  &:hover {
    background-color: $active-light;
  }
  &:active {
    background-color: $active-dark;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    &:hover {
      background-color: $active;
    }
  }
}
// Зеленая кнопка outline
.green.outline {
  color: $active;

  background-color: inherit;
  border: 0.0667rem solid rgba($active, 0.5);
  box-shadow: none;
  &:hover {
    background-color: inherit;
    border: 0.0667rem solid $active;
  }
  &:active {
    background-color: $active-btnActive;
  }
  &:disabled {
    background-color: $active-btnActive;
    opacity: 0.4;
    &:hover {
      background-color: $active-btnActive;
      border: 0.0667rem solid rgba($active, 0.5);
    }
  }
}
.green.outline.big {
  /* border: 0.0667rem solid $extra-active; */
  // background-color: transparent;
  box-shadow: none;
  &:hover {
    // transform: unset !important;
    // background-color: transparent !important;
    border: 0.0667rem solid $active;
    box-shadow: none !important;
  }
  &:active {
    background-color: $active-btnActive !important;
    box-shadow: none;
  }
}
// Оранжевая кнопка ===========================
.orange {
  color: $text-super-light;

  background-color: $extra-active;
  &:not(:disabled):hover {
    background-color: $extra-active-light;
  }
  &:not(.big):active {
    background-color: $extra-active-dark;
  }
  &:disabled {
    &:hover {
      background-color: $extra-active;
    }
  }
}

// Оранжевая кнопка outline
.orange.outline {
  color: $extra-active;

  background-color: rgba($extra-active, 0.05);
  border: 0.0667rem solid rgba($extra-active, 0.5);
  box-shadow: none;
  &:hover {
    background-color: rgba($extra-active, 0.05);
    border: 0.0667rem solid $extra-active;
  }
  &:active {
    background-color: rgba($extra-active, 0.1);
  }
  &:disabled {
    opacity: 0.4;
    &:hover {
      background-color: rgba($extra-active, 0.05);
      border: 0.0667rem solid rgba($extra-active, 0.5);
    }
  }
}

.orange.outline.big {
  /* border: 0.0667rem solid $extra-active; */
  background-color: $bg-main;
  box-shadow: none;
  &:hover {
    background-color: $bg-main;
    border: 0.0667rem solid $extra-active;
    box-shadow: none;
  }
  &:active {
    background-color: rgba($extra-active, 0.05);
  }
}

//Серая кнопка ================================
.gray {
  color: $text-second;

  background-color: $soft;
  box-shadow: none;
  &:hover {
    background-color: $soft-hover;
    box-shadow: none;
  }
  &:active {
    background-color: $soft-active;
  }
  &:disabled {
    &:hover {
      background-color: $soft;
    }
  }
}
// Серая кнопка outline
.gray.outline {
  color: $text-second;

  background-color: $bg-main;
  border: solid 0.0667rem $text-soft;
  &:not(:disabled):hover {
    border: solid 0.0667rem $border-soft-hover;
  }
  &:active {
    background-color: $bg-soft-active;
    border: solid 1px $text-soft;
  }
  &:disabled {
    opacity: 0.4;
    &:hover {
      background-color: $bg-main;
      border: solid 0.0667rem $text-soft;
    }
  }
}

// Светлозелёная ====================================
.lightGreen {
  color: $active;
  background-color: $active-superlight;
  &:hover {
    background-color: rgba($active-superlight, 0.5);
  }
  &:active {
    background-color: #ceebe8;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    &:hover {
      background-color: $active-superlight;
    }
  }
}
// Большая кнопка ====================================
.big {
  min-width: 13.3333rem;
  height: 3.2rem;
  // padding: 0.7rem 1.6rem 0.8rem;
}

.big.green {
  box-shadow: 0 0.6667rem 0.6667rem 0 rgba($active, 0.2);
  &:not(:disabled):not(.gray):hover {
    /* background-color: $active; */
    box-shadow: 0 1rem 1rem 0 rgba($active, 0.2);
    transform: translateY(-0.0667rem);
  }
  &:not(.gray):not(.orange):active {
    background-color: $active-dark;
    box-shadow: 0 0.6667rem 0.6667rem 0 rgba($active, 0.2);
    transform: translateY(0);
  }
}

.big.orange {
  box-shadow: 0 0.6667rem 0.6667rem 0 rgba($extra-active, 0.2);
  &:hover {
    /* background-color: $extra-active; */
    box-shadow: 0 1rem 1rem 0 rgba($extra-active, 0.2);
    transform: translateY(-0.0667rem);
  }
  &:active {
    background-color: $extra-active-dark;
    box-shadow: 0 0.6667rem 0.6667rem 0 rgba($extra-active, 0.2);
    transform: translateY(0);
  }
}

.big.gray {
  box-shadow: none;
  &:hover {
    box-shadow: none;
    transform: translateY(-0.0667rem);
  }
  &:active {
    box-shadow: none;
    transform: translateY(0);
  }
}
</style>
